import { SignupLeadProgressV3 } from 'domains/signupv3/Leads/types';
import { isBoolean } from 'lodash';

export const getSignupResumeCheckGuard = (key: keyof SignupLeadProgressV3) => {
  return (_: unknown, params: { progress: SignupLeadProgressV3 }) => {
    const value = params.progress[key];
    return isBoolean(value) && value === true;
  };
};
